<template>
  <PageHeader :pageTitle="pageTitle" />
  <div class="container mb-5 mt-5">
    <div v-html="html" class="wysiwyg"></div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import axios from "@/http";
import { useStore } from "vuex";
import { ref } from "@vue/reactivity";
import { onMounted, onUpdated } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import usePretendFetchData from "@/composables/usePretendFetchData";

export default {
  components: { PageHeader },
  setup() {
    const route = useRoute();
    const store = useStore();
    const html = ref(null);
    const pageTitle = ref(null);

    const setData = (data) => {
      pageTitle.value = data.title;
      html.value = data.body;
    };

    // onMounted(async () => {
    //   const res = await axios.post(
    //     route.name,
    //     {},
    //     { headers: { Authorization: `Bearer ${store.state.token}` } }
    //   );

    //   html.value = res.data.data.body;
    //   pageTitle.value = res.data.data.title;
    // });

    return { html, pageTitle, setData };
  },
  beforeRouteEnter(to, from, next) {
    usePretendFetchData(to.name, false, (data) => {
      next((vm) => vm.setData(data));
    });
  },
  // beforeRouteUpdate(to, from, next) {
  //   usePretendFetchData(to.name, false, (data) => {
  //     this.setData(data);
  //     next();
  //   });
  // },
};
</script>

<style>
</style>